import { DeviceAssociationGetAllResponse } from '@quromedical/models';
import { useMemo } from 'react';
import { trpc } from 'trpc';

export const useActiveDeviceAssociations = (
  patientId: string[]
): DeviceAssociationGetAllResponse => {
  const subject = patientId.join(',');

  const { data } = trpc.context.device.usage.getAll.useQuery({
    subject,
  });

  const associations = data?.associations.filter(association => association.status === 'active');
  const deviceAssignments = useMemo(() => associations || [], [associations]);

  return {
    associations: deviceAssignments,
  };
};
